import Vue from 'vue';
import Vuex from 'vuex';
import Service from './modules/service';
Vue.use(Vuex);
const appstore = () => {
    return new Vuex.Store({
        modules: {
            Service
        }
    });
};
export default appstore;
